import React, { createContext, Dispatch, ReactNode, useReducer } from 'react';
import { AppAction } from './actions';
import { appReducer, AppState, initialState } from './reducer';

interface ExploraProviderInterface {
  children: ReactNode;
}

const ExploraStateContext = createContext<AppState | undefined>(undefined);
const ExploraDispatchContext = createContext<Dispatch<AppAction> | undefined>(undefined);

const ExploraProvider = ({ children }: ExploraProviderInterface) => {
  const [state, dispatch] = useReducer(appReducer, initialState);

  return (
    <ExploraStateContext.Provider value={state}>
      <ExploraDispatchContext.Provider value={dispatch}>{children}</ExploraDispatchContext.Provider>
    </ExploraStateContext.Provider>
  );
};

const useExploraState = () => {
  const context = React.useContext(ExploraStateContext) as AppState;

  if (context === undefined) {
    throw new Error('useExploraState must be used within a ExploraStateContext');
  }

  return context;
};

const useExploraDispatch = () => {
  const context = React.useContext(ExploraDispatchContext) as Dispatch<AppAction>;

  if (context === undefined) {
    throw new Error('useExploraDispatch must be used within a ExploraDispatchContext');
  }

  return context;
};

export { ExploraProvider, useExploraState, useExploraDispatch };
